// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7337) return "static/chunks/ad2866b8-d1d8a11f85b29912.js";
	if (chunkId === 817) return "static/chunks/817-3706d941872333c9.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"500":"a0ceb558ff6aecf3","7583":"2f1dce67cd621498","8445":"ac669e7e26577725"}[chunkId] + ".js";
};